import { Component, computed, input } from '@angular/core';

import { Modal } from 'bootstrap';
import {
	DriverSalary,
	DriversSalaryDetails,
} from '@/drivers/drivers-salary-common/drivers-salary-month-list/drivers-salary-month-list.component';

interface DriversSalaryWithCount {
	value: number;
	count: number;
	name: string;
	comment: string;
	currency: string;
	month: string;
}

@Component({
	selector: 'app-drivers-modal-info',
	templateUrl: './drivers-modal-info.component.html',
	styleUrls: ['./drivers-modal-info.component.css'],
})
export class DriversModalInfoComponent {
	readonly driverSalarySummary = input.required<DriverSalary>();

	readonly driversSalaryWithCount = computed(() =>
		this.driverSalarySummary()
			? Object.fromEntries(
					Object.entries(this.driverSalarySummary()).map(([key, { details }]) => [
						key,
						this.countDuplicateSalaryValues(details),
					]),
				)
			: null,
	);

	showBonusPositive(): void {
		if (this.driverSalarySummary().sumBenefits.details.length) {
			new Modal(document.getElementById('bonusPositive')).show();
		}
		return;
	}

	showBonusNegative(): void {
		if (this.driverSalarySummary().sumDeduction.details.length) {
			new Modal(document.getElementById('bonusNegative')).show();
		}
		return;
	}

	showSalaryInfo(): void {
		if (this.driverSalarySummary().sumRates.details.length) {
			new Modal(document.getElementById('addModal')).show();
		}
		return;
	}

	dialogClose(type: string): void {
		const modal = Modal.getInstance(document.getElementById(type));
		if (!modal) {
			return;
		}
		modal.hide();
		return;
	}

	private countDuplicateSalaryValues(data: DriversSalaryDetails[] = []): DriversSalaryWithCount[] {
		if (data.length === 0) return [];

		const groupedData = new Map<string, DriversSalaryWithCount>();

		for (const { value, name, comment, currency, month } of data) {
			const key = `${value.toString()}_${currency}_${name}_${comment}`; //adding comment as some of payments were merging when they were not supposed to

			if (groupedData.has(key)) {
				groupedData.get(key)!.count++;
			} else {
				groupedData.set(key, {
					value,
					count: 1,
					name,
					comment,
					currency,
					month,
				});
			}
		}

		return Array.from(groupedData.values());
	}
}
